import {
  formatDateTime,
  formatCurrency,
  formatNumber,
  getTimezoneDate,
  timezones,
} from "../../utilities/helpers";

import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";

export default function SettlementReport({ data }) {
  const orders = data?.sales_data?.filter(
    (d) =>
      (d.source === "website" && d.payment_method_type === "cash") ||
      (d.source === "box_office" && d.payment_method_type === "cash") ||
      (d.assignment_type === "individual" && d.payment_option === "cash") ||
      (d.assignment_type === "group" &&
        d.payment_option === "cash" &&
        d.complimentary === false),
  );

  const feesCollected = orders.reduce(
    (acc, cur) => acc + cur.serviceFeeTotal,
    0,
  );

  const onlineTotalCollected =
    data?.onlineNetSales +
    data?.boxOfficeCardNetSales +
    data?.assignedIndividualCardNetSales +
    data?.assignedGroupCardNetSales;
  return (
    <Card body className="card--md card-with-border">
      <div className="card-body-heading card-body-heading--sm">
        <Card.Title as="h5">{data?.event[0]?.name}</Card.Title>
        <Card.Subtitle as="h6" className="mt-2">
          {formatDateTime(
            getTimezoneDate(
              data?.event[0]?.start,
              timezones(data?.event[0]?.venue[0]?.timezone),
            ),
            "dateOnly",
          )}
        </Card.Subtitle>
      </div>
      <Card body className="card--light card--md card-with-border">
        <Table>
          <thead>
            <tr>
              <th>Payment source</th>
              <th>Quantity</th>
              <th>Net sales</th>
            </tr>
          </thead>
          <tbody>
            <>
              <tr>
                <td>Online/Card (blocktickets.xyz)</td>
                <td>
                  {formatNumber(
                    data?.onlineTicketQty +
                      data?.boxOfficeCardTicketQty +
                      data?.assignedIndividualCardTicketQty +
                      data?.assignedGroupCardTicketQty,
                  )}
                </td>
                <td>
                  {formatCurrency(
                    data?.onlineNetSales +
                      data?.boxOfficeCardNetSales +
                      data?.assignedIndividualCardNetSales +
                      data?.assignedGroupCardNetSales,
                  )}
                </td>
              </tr>
              <tr>
                <td>Cash/Check (Team Collected)</td>
                <td>
                  {formatNumber(
                    data?.boxOfficeNonCardTicketQty +
                      data?.assignedIndividualNonCardTicketQty +
                      data?.assignedGroupNonCardTicketQty,
                  )}
                </td>
                <td>
                  {formatCurrency(
                    data?.boxOfficeNonCardNetSales +
                      data?.assignedIndividualNonCardNetSales +
                      data?.assignedGroupNonCardNetSales,
                  )}
                </td>
              </tr>
              <tr>
                <td>Comp</td>
                <td>
                  {formatNumber(
                    data?.assignedCompTicketQty + data?.compBoxOfficeTicketQty,
                  )}
                </td>
                <td>{formatCurrency(data?.compNetSales)}</td>
              </tr>
              <tr>
                <td>Packages</td>
                <td>{formatNumber(data?.packagesTicketQty)}</td>
                <td>0</td>
              </tr>
              <tr className="total-row">
                <td>Fees Owed on Cash Sales</td>
                <td></td>
                <td>{formatCurrency(feesCollected)}</td>
              </tr>
              <tr className="total-row">
                <td>Final Payout to Team</td>
                <td></td>
                <td>{formatCurrency(onlineTotalCollected - feesCollected)}</td>
              </tr>
            </>
          </tbody>
        </Table>
      </Card>
    </Card>
  );
}
